import { useLocation } from '@reach/router';
import { Select } from 'antd';
import { navigate, withPrefix } from 'gatsby';
import React, { useContext } from 'react';

import { Media } from '../components/Media';
import TagCloud from '../components/TagCloud';
import { BlogType } from '../models/blog';
import { GhostTag } from '../models/ghost';
import { SearchContext } from '../store/SearchContext';
import { getTagsMap } from '../utils/search';

const { Option } = Select;

const TagsListContainer: React.FC = () => {
  const location = useLocation();
  const [searchFilters, setParam] = useContext(SearchContext);

  const blogType = process.env.GATSBY_BLOG_TYPE as BlogType;

  const tags = getTagsMap();

  const handleSelect = (slug: string) => {
    if (location.pathname !== withPrefix('/search')) {
      navigate(`/search?tag=${slug}`);
    } else {
      setParam("tags", slug);
    }
  };

  const handleToggle = (tag: GhostTag) => {
    if (location.pathname !== withPrefix('/search')) {
      navigate(`/search?tag=${tag.slug}`);
      return;
    }

    if (searchFilters.tags && searchFilters.tags.length > 0) {
      const filteredTags = searchFilters.tags.filter(
        filter => filter.slug !== tag.slug
      );
      if (filteredTags.length === searchFilters.tags.length) {
        filteredTags.push(tag);
      }
      setParam("tags", filteredTags.map(tag => tag.slug));
    } else {
      setParam("tags", [tag.slug]);
    }
  };

  return (
    <React.Fragment>
      <Media greaterThanOrEqual='md'>
        <TagCloud
          tags={tags}
          selected={searchFilters.tags || []}
          onSelect={handleToggle}
        />
      </Media>
      <Media lessThan='md'>
        <Select
          showSearch
          placeholder='Search tags'
          onChange={handleSelect}
          style={{ width: '100%' }}
          value={
            (searchFilters.tags &&
              searchFilters.tags.length > 0 &&
              searchFilters.tags[0].slug) ||
            undefined
          }
        >
          {tags.map((tag, index) => (
            <Option key={index} value={tag.slug}>
              {tag.name}
            </Option>
          ))}
        </Select>
      </Media>
    </React.Fragment>
  );
};

export default TagsListContainer;
